import React, { useState, useMemo, useEffect } from 'react';
import moment from "moment";
import {
  EuiButton,
  EuiFormRow,
  EuiPopover,
  EuiSpacer,
  EuiDatePickerRange,
  EuiPanel,
  EuiAccordion, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiSwitch
} from '@elastic/eui';
import SelectorFecha from '../../../../../../shared/components/Combos/Fecha';
import { ToSQL } from '../../../../../../shared/utils/fecha';
import { HistoricoFacturacionComponent } from './HistoricoFacturacionComponent';
import { FacturacionComponent } from './FacturacionComponent';
import ComboTiposFacturacion from '../../../../components/Selectores/TiposFacturacion/combo';
import { AppAdapter } from '../../../../../../infraestructure/persistence/rest/AppAdapter';

const getTiposFacturacion = async(set) =>{
  const api = new AppAdapter();
let result;

  try {
      result = await api.GetTiposFacturacion();
      if(result.data && result.data!=="")
      {
          set && set(([ ...result.data ] || []))
      }
  } catch (error) {
  }
}

export const SelectorFechasDescarga = (props) =>{

    const {onDownLoad, showFacturacionUser, onFacturar} = props;
    const fIni = moment().startOf('year');
    const fFin = moment().endOf('month');

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [fechaIni, setFechaIni] = useState(fIni);
    const [fechaFin, setFechaFin] = useState(fFin);
    const [soloValidados, setSoloValidados] = useState(false);
    const [tipoFacturacion, setTipoFacturacion] = useState(undefined);
    const [tipos, setTipos] = useState(undefined);

    useEffect(()=>{getTipos();},[])
    
    const getTipos = async() =>{
      await getTiposFacturacion(setTipos);
  }

    const onButtonClick = () =>
        setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    const button = (
        <EuiButton size='s' iconType="arrowDown" iconSide="right" onClick={onButtonClick} fill style={{borderRadius:'0px'}}>
        {`Facturación`}
        </EuiButton>
    );

    const dateFormat = useMemo(() =>{
      const fi = ToSQL(fechaIni,"-")
      const ff = ToSQL(fechaFin,"-")
      return {dateFormatIni:fi,dateFormatFin:ff}
    },[fechaIni,fechaFin])

    const onClickDownload = (tipoFichero,tipoFac,fechaFacturacion) =>{
      const _tipoFacturacion = fechaFacturacion!==undefined?tipoFac:tipoFacturacion;
      const dateRange = dateFormat
      const dataDownLoad = {
        tipo:tipoFichero, tipoFacturacion:_tipoFacturacion, fechaDesde: dateRange.dateFormatIni, fechaHasta: dateRange.dateFormatFin, fechaFacturacion: fechaFacturacion, soloValidados: soloValidados
      }
      
      onDownLoad && onDownLoad(dataDownLoad)
      closePopover()
    }

    const onClickFacturar = (dataFacturacion) =>{
      const dateRange = dateFormat;
      const dataFacturacionFinally = {fechaDesde: dateRange.dateFormatIni, fechaHasta: dateRange.dateFormatFin, ...dataFacturacion, tipoFacturacion:tipoFacturacion.idSociedadOriginal}
      onFacturar(dataFacturacionFinally);
    }

    const getFacturacionPorUsuario = useMemo(() =>{
      if(showFacturacionUser.descFacUsuario === true)
      {
        return (
          <>
          <EuiSpacer />
          <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>onClickDownload('FU')}>{`Facturación por Usuario`}</EuiButton>
        </>
        )
      }
    },[showFacturacionUser,onClickDownload])

    const getFacturacionPorProvincia = useMemo(() =>{
      if(showFacturacionUser.descFacProvincia === true)
      {
        return (
          <>
            <EuiSpacer />
            <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>onClickDownload('PV')}>{`Facturación por Provincia`}</EuiButton>
          </>
        )
      }
    },[showFacturacionUser,onClickDownload])


    return (
        <EuiPopover
          ownFocus={false}
          button={button}
          isOpen={isPopoverOpen}
          closePopover={closePopover}
          initialFocus="[id=asdf2]">
            <EuiAccordion
            id={`fact-acord-1`}
            buttonContent="Ficheros Facturación"
            paddingSize="l"
            className='euiAccordionForm'
            >
            <EuiPanel>
            <EuiFlexGroup alignItems='center'>
              <EuiFlexItem>
                <EuiFormRow
                  label="Rango de fechas"
                  id="asdf"
                  hasChildLabel={false}>
                  
                  <EuiDatePickerRange
                  fullWidth
                  compressed
                  startDateControl={
                      <SelectorFecha
                      selected={fechaIni}
                      onChange={(value)=>setFechaIni(value)}
                      isInvalid={fechaIni > fechaFin}
                      aria-label="Inicio"
                      />
                  }
                  endDateControl={
                      <SelectorFecha
                      selected={fechaFin}
                      onChange={(value)=>setFechaFin(value)}
                      isInvalid={fechaIni > fechaFin}
                      aria-label="Fin"
                      />
                  }
                  />
                  </EuiFormRow>
              </EuiFlexItem>
              
              <EuiFlexItem>
                <EuiFlexGroup direction='column'>
                      <EuiFlexItem>
                        <ComboTiposFacturacion data={tipos} valueOfSelected={tipoFacturacion} onChange={value => setTipoFacturacion(value)} compressed/>
                      </EuiFlexItem>
                      <EuiFlexItem grow={false}>
                        <EuiSwitch compressed checked={soloValidados} onChange={(e)=>{setSoloValidados(e.target.checked)}} label="Solo Validados"/>
                      </EuiFlexItem>
                </EuiFlexGroup>
              </EuiFlexItem>

            </EuiFlexGroup>
            </EuiPanel>
            <EuiSpacer />
            <EuiButton className='btn-download-popup' fullWidth fill size='s' onClick={()=>onClickDownload('CP')}>{`Facturación por CP`}</EuiButton>
            {getFacturacionPorProvincia}
            <EuiSpacer />
            <EuiFlexItem>
                <EuiButton className='btn-download-popup' fill size='s' onClick={()=>onClickDownload('FF')}>{`Facturación Final`}</EuiButton>
            </EuiFlexItem>
            {getFacturacionPorUsuario}
            {/* <EuiSpacer /> 
            <FacturacionComponent onFacturar={onClickFacturar} /> */}
        </EuiAccordion>
        <EuiSpacer size='m'/>
        <EuiAccordion
          id={`fact-acord-2`}
          buttonContent="Histórico Facturación"
          paddingSize="l"
          className='euiAccordionForm'
          >
          <HistoricoFacturacionComponent onSave={onClickDownload} 
          showFacturacionUsu={showFacturacionUser.descFacUsuario}
          showFacturacionProvincia={showFacturacionUser.descFacProvincia}
          />
        </EuiAccordion>
        </EuiPopover>
      );
}